import React from 'react'

import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react'

import { formatApproverSlotLabel } from '../helper/approverSlotMatching.helper'

// A user can simultaneously hold more than one approver/invitee slot on the same
// offer. One match: act on it directly, same as a plain button. More than one:
// show a picker instead of silently acting on only the first match.
const ApproverSlotActionButton = ({ label, slots, onSelect, isLoading, colorScheme }) => {
  if (!Array.isArray(slots) || slots.length === 0) {
    return null
  }

  if (slots.length === 1) {
    return (
      <Button colorScheme={colorScheme} isLoading={isLoading} onClick={() => onSelect(slots[0])}>
        {label}
      </Button>
    )
  }

  return (
    <Menu>
      <MenuButton as={Button} colorScheme={colorScheme} isLoading={isLoading}>
        {label}
      </MenuButton>
      <MenuList>
        {slots.map((slot) => (
          <MenuItem key={slot.approverIndex} onClick={() => onSelect(slot)}>
            {formatApproverSlotLabel(slot.detail)}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  )
}

export default ApproverSlotActionButton
